import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class AreaCodesEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  http = inject(HttpClient);

  get(polling?: boolean) {
    return this.http.get<string[]>(
      `${this.env.constants.API_URL}/areacodes${polling ? '?polling=true' : ''}`,
    );
  }
}
